<template>
  <footer class="footer has-background-white">
    <div class="content">
      <div class="columns">
        <div class="column"></div>
        <div class="column">
          <img src="@/assets/images/logo-zbieraj-monety-male.png" />
          <h3 class="subtitle">ZbierajMonety.pl</h3>
          <ul>
            <li>
              <a class="link">O nas</a>
            </li>
            <li>
              <a class="link">Polityka Prywatności</a>
            </li>
            <li>
              <a class="link">Regulamin</a>
            </li>
          </ul>
        </div>
        <div class="column">
          Wszystkie Prawa zastrzeżone
          <ul>
            <li>
              <a class="link">Zgłoś błąd na stronie</a>
            </li>
            <li>
              <a class="link">Reklama</a>
            </li>
            <li>
              <router-link :to="{name: 'sitemap'}" class="link">Mapa Strony</router-link>
            </li>
          </ul>
        </div>
        <div class="column"></div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterSection"
};
</script>
